import millify from "millify";

export default function millifyWatts(num: number) {
  return millify(num, {
    precision: 0,
    units: ["Watts", "kW", "MW", "GW", "TW"],
    space: true,
  });
}
